/** Min-width breakpoints in px. CSS uses the generated `@custom-media --gg-md` etc.; JS uses these. */
export const breakpoints = { sm: 480, md: 768, lg: 1024, xl: 1280 } as const;

export type Breakpoint = keyof typeof breakpoints;

export const mediaQuery = (bp: Breakpoint) => `(min-width: ${breakpoints[bp]}px)`;
